<app-holder>
  <div fxLayout="column" fxLayoutAlign="start center">

    <button mat-button routerLink="/menu" *ngIf="enableDineIn">View Dine In Menu</button>
    <button mat-button routerLink="/pay" *ngIf="enablePay">Pay</button>
    <button mat-button routerLink="/takeout" *ngIf="enableTakeout">Pickup & Delivery</button>

  </div>
</app-holder>
